import { Stack } from '@mui/material';
import { useMemo } from 'react';
import { Conversation } from 'src/graphql';
import useConversationViewsStore from 'src/store/conversation-views';
import { resolvePartnerTabContactInfo } from './partner-contact-info';
import { PartnerInfo } from './partner-info';
import { PartnerInfoTabs } from './partner-info-tabs';

interface PartnerTabProps {
  conversation: Conversation;
}

export const PartnerTab = ({ conversation }: PartnerTabProps) => {
  const { associatedAddressesPlaceholders } = useConversationViewsStore();

  const conversationAddress = useMemo(
    () =>
      conversation.address ??
      associatedAddressesPlaceholders[conversation.conversationId]?.[0],
    [associatedAddressesPlaceholders, conversation.address, conversation.conversationId],
  );
  const partnerWithBrandGroupContactInfo = useMemo(
    () =>
      resolvePartnerTabContactInfo(
        conversation.partner,
        conversationAddress?.brand?.brandGroupId,
        !!conversationAddress?.brandId,
      ),
    [conversation.partner, conversationAddress?.brand?.brandGroupId, conversationAddress?.brandId],
  );

  return (
    <Stack spacing={2}>
      <PartnerInfo partner={partnerWithBrandGroupContactInfo} />
      {partnerWithBrandGroupContactInfo ? (
        <PartnerInfoTabs
          partner={partnerWithBrandGroupContactInfo}
          address={conversationAddress}
        />
      ) : null}
    </Stack>
  );
};
